<template>
  <div class="infoCenter">
    <div class="title" :style="`background-image:url(${banner.picUrl})`" @click="goBannerUrl" :class="{canClick: banner.connection}">
      <h1>{{title === 'company' ? '企业动态' : '行业动态'}}</h1>
    </div>
    <div class="middle-content detail">
      <aside class="menu">
        <h2 class="canClick" @click="goBack">资讯中心</h2>
        <ul>
          <li v-for="item in menuList" :key="item.id" @click="goMenu(item.pathName)" :class="{active: title === item.id}">{{item.name}}</li>
        </ul>
      </aside>
      <div class="h600">
        <transition name="fade-transform" mode="out-in">
          <div class="article" v-if="detailData.articleTitle">
            <article class="main-art">
              <h1>{{detailData.articleTitle}}</h1>
              <p class="time">发布时间：{{detailData.releaseTime|formatDate}}</p>
              <p class="content" v-html="detailData.articleContent"></p>
            </article>
            <div class="about-news" v-if="detailData.relevantArticle && detailData.relevantArticle.length > 0">
              <h2>相关文章</h2>
              <div class="list" v-for="(item,key) in detailData.relevantArticle" :key="key">
                <p class="name" @click="goOtherArticle(item)">{{item.articleTitle}}</p>
                <p class="time">{{item.releaseTime|formatDate}}</p>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
export default {
  props: {
    title: {
      type: String,
      default: 'company'
    }
  },
  data () {
    return {
      banner: {
        picUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      },
      detailData: {},
      menuList: [
        { name: '企业动态', id: 'company', pathName: 'campanyNews' },
        { name: '行业动态', id: 'pig', pathName: 'pigNews' }
      ]
    }
  },
  filters: {
    formatDate: function (value) {
      const date = new Date(value)
      const y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? ('0' + MM) : MM
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      let m = date.getMinutes()
      m = m < 10 ? ('0' + m) : m
      let s = date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
    }
  },
  mounted () {
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    } else {
      this.banner = this.title === 'pig' ? getSession('bannerPic').wisdom_pig_farm : getSession('bannerPic').enterprise_dynamics
    }
    this.getArticleDetail()
  },
  methods: {
    /**
     * 获取 banner 图片
     */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.basic.getBannerPage(params) || []
      // eslint-disable-next-line prefer-const
      let arr = {}
      res.data.map(o => {
        this.$set(arr, o.remark, { picUrl: o.pictureUrl, connection: o.connection })
      })
      this.banner = this.title === 'pig' ? arr.wisdom_pig_farm : arr.enterprise_dynamics
      setSession('bannerPic', arr)
    },
    /**
     * 文章详情
     */
    async getArticleDetail () {
      const res = await this.API.recruit.getArticleDetail({ articleId: this.$route.query.articleId }) || []
      this.detailData = res.data
      // 过滤状态隐藏的相关文章
      if (this.detailData.relevantArticle && this.detailData.relevantArticle.length > 0) {
        this.detailData.relevantArticle = this.detailData.relevantArticle.filter(o => {
          return o.state === 0 && (o.articleId !== this.detailData.articleId)
        })
      }
    },
    /** 回到主菜单 */
    goMenu (pathName) {
      this.$router.push({
        name: pathName
      })
    },
    /** 跳转相关文章 */
    goOtherArticle (item) {
      const fullPath = item.articleType === '0' ? `/newsDetail/${item.articleId}?articleId=${item.articleId}` : `/pigDetail/${item.articleId}`
      this.$router.replace({
        path: '/redirect' + fullPath,
        query: { articleId: item.articleId }
      })
    },
    /** 跳转banner配置连接 */
    goBannerUrl () {
      if (!this.banner.connection) {
        return ''
      }
      window.open(this.banner.connection)
    },
    goBack () {
      if (this.title === 'pig') {
        this.$router.push({
          name: 'pigNews'
        })
      } else {
        this.$router.push({
          name: 'campanyNews'
        })
      }
    }
  }
}
</script>
